import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-299f4e10"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "submit-order-root"
};
const _hoisted_2 = {
  class: "order-detail-content"
};
const _hoisted_3 = {
  class: "product-info"
};
const _hoisted_4 = {
  class: "left-part"
};
const _hoisted_5 = {
  class: "price"
};
const _hoisted_6 = {
  class: "price-number"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "price-tag"
}, "RMB", -1));

const _hoisted_8 = {
  class: "title-box"
};
const _hoisted_9 = {
  class: "title-text"
};
const _hoisted_10 = {
  class: "img-box"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  key: 0,
  class: "use-date-text"
};
const _hoisted_13 = {
  class: "useful-desc"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请于活动当日提前一小时至半小时入场；", -1));

const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = {
  class: "ticket-count"
};
const _hoisted_17 = {
  class: "line-1"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ticket-count-title"
}, "票品数量", -1));

const _hoisted_19 = {
  key: 0,
  class: "ticket-desc"
};
const _hoisted_20 = {
  key: 1,
  class: "ticket-desc"
};
const _hoisted_21 = {
  key: 1,
  class: "discount-info"
};
const _hoisted_22 = {
  class: "top"
};
const _hoisted_23 = {
  key: 0,
  class: "discount-bottom"
};
const _hoisted_24 = {
  class: "bill-info"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "价格明细", -1));

const _hoisted_26 = {
  class: "bill-detail"
};
const _hoisted_27 = {
  class: "item"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fontB"
}, "票品总价", -1));

const _hoisted_29 = {
  class: "amount"
};
const _hoisted_30 = {
  key: 0,
  class: "item"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fontB"
}, "第二件半价优惠", -1));

const _hoisted_32 = {
  key: 1,
  class: "item"
};

const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fontB"
}, "优惠码优惠", -1));

const _hoisted_34 = {
  class: "item price-item"
};

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fontB"
}, "订单合计：", -1));

const _hoisted_36 = {
  class: "price"
};

const _hoisted_37 = /*#__PURE__*/_createTextVNode(" ¥ ");

const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"payment-info\" data-v-299f4e10><div class=\"title\" data-v-299f4e10>支付方式</div><div class=\"payment-detail\" data-v-299f4e10><div class=\"circle-outside\" data-v-299f4e10><div class=\"circle-inside\" data-v-299f4e10></div></div><div class=\"wx-pay-text\" data-v-299f4e10>微信支付</div></div></div><div class=\"payment-info-tip\" data-v-299f4e10>票品售出，除因不可抗力因素导致大会延期或取消，其他不支持退改</div>", 2);

const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-tip"
}, "扫描下方二维码完成支付", -1));

const _hoisted_41 = {
  class: "share-img-wrapper"
};
const _hoisted_42 = ["src"];
const _hoisted_43 = {
  class: "go-to-buy-bar"
};
const _hoisted_44 = {
  class: "price-text"
};
const _hoisted_45 = {
  key: 0,
  class: "pay-new-btn-box"
};
const _hoisted_46 = {
  key: 1,
  class: "pay-new-btn-box"
};
const _hoisted_47 = {
  key: 0,
  class: "is-buied-student-btn-empty"
};
const _hoisted_48 = {
  key: 1,
  class: "is-buied-student-btn"
};
import { useRoute } from "vue-router";
import { ref, watch, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { Dialog, Toast } from "vant";
import TopNavigator from "../components/TopNavigator.vue";
import { initWxJssdk, jsonify, encodeRSA, browserType, date2ISO, getServerTime } from "../assets/utils/common.utils";
import router from "../router";
import AV from "../assets/utils/av";
import request from "../assets/utils/request";
import { nftShopApi, payTypeEunm, SALTSTR } from "../common.config";
import wx from "weixin-js-sdk";
import CommonBtn from "../components/CommonBtn.vue";
import dayjs from "dayjs";
export default {
  __name: 'SubmitOrder',
  props: {},

  setup(__props) {
    const props = __props;
    const VanDialog = Dialog.Component;
    const curRouter = useRoute(); // 票品单价

    const price = ref(99999999);
    const priceDisplay = computed(() => price.value / 100); // 订单原始总价

    const ticketOriginTotalFee = computed(() => {
      if (price.value && ticketCount.value) {
        return price.value * ticketCount.value;
      } else {
        return 0;
      }
    });
    const ticketOriginTotalFeeDisplay = computed(() => (ticketOriginTotalFee.value / 100).toFixed(2)); // 第二件半价优惠

    const secondHalfDiscount = computed(() => {
      if (ticketInfo.value.type == 1) {
        return Math.floor(ticketCount.value / 2) * (price.value / 2);
      } else {
        return 0;
      }
    });
    const secondHalfDiscountDisplay = computed(() => {
      return (secondHalfDiscount.value / 100).toFixed(2);
    }); // =========优惠码相关=========start
    // 优惠码折扣值，如70、90

    const discountCodeRate = ref(100); // 优惠码几折数值展示

    const discountCodeRateDispaly = computed(() => {
      if (1 <= discountCodeRate.value && discountCodeRate.value < 100) {
        return discountCodeRate.value / 10;
      } else {
        return "";
      }
    }); // 优惠码优惠金额

    const discountCodeAmount = computed(() => {
      if (discountCodeRate.value && 1 <= discountCodeRate.value && discountCodeRate.value < 100) {
        return ticketOriginTotalFee.value - secondHalfDiscount.value - (ticketOriginTotalFee.value - secondHalfDiscount.value) * discountCodeRate.value / 100;
      } else {
        return 0;
      }
    });
    const discountCodeAmountDisplay = computed(() => {
      return (discountCodeAmount.value / 100).toFixed(2);
    }); // 优惠码ID

    const discountCodeId = ref(""); // 优惠码值

    const discountCode = ref(""); // 优惠码兑换验证提示  有效/无此优惠码

    const verificationInfo = ref(""); // 监听优惠码兑换

    watch(discountCode, (newVal, oldVal) => {
      if (newVal) {
        const query = curRouter.query;
        const productId = query === null || query === void 0 ? void 0 : query.productId;
        const discountCodeQuery = new AV.Query("PromotionCode");
        const regStr = new RegExp(`^${discountCode.value}$`, "i");
        discountCodeQuery.matches("code", regStr);
        discountCodeQuery.first().then(res => {
          if (res) {
            const discountCodeRes = jsonify(res);
            console.log("discountCodeRes: ", discountCodeRes);
            getServerTime().then(sTime => {
              const st = date2ISO(sTime);

              if (discountCodeRes.isValid && dayjs(discountCodeRes === null || discountCodeRes === void 0 ? void 0 : discountCodeRes.expiresAt) >= dayjs(st)) {
                var _discountCodeRes$tick, _discountCodeRes$tick2, _discountCodeRes$tick3, _discountCodeRes$tick4;

                if (discountCodeRes !== null && discountCodeRes !== void 0 && (_discountCodeRes$tick = discountCodeRes.ticketCat) !== null && _discountCodeRes$tick !== void 0 && _discountCodeRes$tick.objectId && (discountCodeRes === null || discountCodeRes === void 0 ? void 0 : (_discountCodeRes$tick2 = discountCodeRes.ticketCat) === null || _discountCodeRes$tick2 === void 0 ? void 0 : _discountCodeRes$tick2.objectId) != productId) {
                  verificationInfo.value = "专属优惠码，此商品无法使用";
                  discountCodeRate.value = 100;
                  discountCodeId.value = "";
                } else if (discountCodeRes !== null && discountCodeRes !== void 0 && (_discountCodeRes$tick3 = discountCodeRes.ticketCat) !== null && _discountCodeRes$tick3 !== void 0 && _discountCodeRes$tick3.objectId && (discountCodeRes === null || discountCodeRes === void 0 ? void 0 : (_discountCodeRes$tick4 = discountCodeRes.ticketCat) === null || _discountCodeRes$tick4 === void 0 ? void 0 : _discountCodeRes$tick4.objectId) == productId) {
                  discountCodeRate.value = discountCodeRes.discountAmount;
                  discountCodeId.value = discountCodeRes.objectId;
                  verificationInfo.value = "";
                } else {
                  discountCodeRate.value = discountCodeRes.discountAmount;
                  discountCodeId.value = discountCodeRes.objectId;
                  verificationInfo.value = "";
                }
              } else if (dayjs(discountCodeRes === null || discountCodeRes === void 0 ? void 0 : discountCodeRes.expiresAt) < dayjs(st)) {
                verificationInfo.value = "优惠码已过期";
                discountCodeRate.value = 100;
                discountCodeId.value = "";
              } else {
                verificationInfo.value = "优惠码无效";
                discountCodeRate.value = 100;
                discountCodeId.value = "";
              }
            }).catch(err => {
              console.error("获取服务器时间 err: ", err);
            });
          } else {
            verificationInfo.value = "请输入正确的优惠码";
            discountCodeRate.value = 100;
            discountCodeId.value = "";
          }
        }).catch(err => {
          verificationInfo.value = "优惠码查询出错";
          discountCodeRate.value = 100;
          discountCodeId.value = "";
          console.log("验证码查询: ", err);
        });
      } else {
        verificationInfo.value = "";
        discountCodeRate.value = 100;
        discountCodeId.value = "";
      }
    }); // =========优惠码相关=========end
    // 订单最终计算总价

    const totalFee = computed(() => {
      const total = ticketOriginTotalFee.value - secondHalfDiscount.value - discountCodeAmount.value;

      if (!total || total <= 0) {
        total = 1;
      }

      return Number(total.toFixed(0));
    });
    const totalFeeDisplay = computed(() => {
      return (totalFee.value / 100).toFixed(2);
    });
    onBeforeMount(() => {
      fetch();
    });
    onBeforeUnmount(() => {
      clearTimeout(timer1.value);
    }); // 票品件数-数量变化前监听

    const ticketCount = ref(1);

    const onCountBeforeChange = value => {
      return new Promise(resolve => {
        // 在 resolve 函数中返回 true 或 false
        if (value) {
          ticketCount.value = value;
          resolve(true);
        } else {
          ticketCount.value = 1;
          resolve(false);
        }
      });
    }; // 获取票种信息


    const ticketInfo = ref({});

    const fetch = () => {
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      const query = curRouter.query;
      const productId = query === null || query === void 0 ? void 0 : query.productId;
      const orderId = query === null || query === void 0 ? void 0 : query.orderId;

      if (productId) {
        request.get(`${nftShopApi}/ticket_cat/info/${productId}`).then(res => {
          ticketInfo.value = res.data; // 如果购买学生票，检查是否超过购买限制

          if (ticketInfo.value.type == 2) {
            request.get(`${nftShopApi}/ticket_cat/buyed_stu_ticket?ticket_cat_id=${ticketInfo.value.objectId}`).then(res => {
              if (res.data) {
                ticketInfo.value.beBuiedStudent = true;
              } else {
                ticketInfo.value.beBuiedStudent = false;
              }
            }).catch(err => {
              console.error("获取学生票购买状态err:", err);
            });
          }

          price.value = ticketInfo.value.price;
          const days = ticketInfo.value.days;
          const len = days.length;
          ticketInfo.value.usefulDuration = [];

          if (len === 1) {
            const arrDays = days[0].split("T");
            ticketInfo.value.usefulDuration.push("2022." + arrDays[0] + " " + (arrDays[1] || ""));
          } else {
            days.forEach(day => {
              const arrDays = day.split("T");
              ticketInfo.value.usefulDuration.push("2022." + arrDays[0] + " " + (arrDays[1] || ""));
            });
          }

          Toast.clear(true);
        }).catch(err => {
          Toast.fail("订单信息错误");
          router.replace("/");
          console.error("获取订单信息：", err);
        });
      }

      if (orderId) {
        console.log("from order");
      }
    }; //调起微信支付


    const onBuy = () => {
      const curUser = AV.User.current() && AV.User.current().toJSON();

      if (curUser) {
        var _curUser$authData, _curUser$authData$wei;

        Toast.loading({
          message: "发起支付...",
          forbidClick: true
        });
        let payType = payTypeEunm.JSAPI;

        if (browserType.versions.wx) {
          payType = payTypeEunm.JSAPI;
        } else if (browserType.versions.mobile || browserType.versions.ios || browserType.versions.android || browserType.versions.iPhone || browserType.versions.iPad) {
          payType = payTypeEunm.H5;
        } else {
          payType = payTypeEunm.NATIVE;
        }

        const {
          productId
        } = curRouter.query;
        const openid = curUser === null || curUser === void 0 ? void 0 : (_curUser$authData = curUser.authData) === null || _curUser$authData === void 0 ? void 0 : (_curUser$authData$wei = _curUser$authData.weixin) === null || _curUser$authData$wei === void 0 ? void 0 : _curUser$authData$wei.openid;

        if (browserType.versions.wx && !openid) {
          Toast.fail("未绑定微信\n请重新登录");
          router.replace("/login");
          return;
        }

        const orderParmas = {
          pay_type: payType,
          user_id: curUser.objectId,
          ticketcat_id: productId,
          total_fee: totalFee.value,
          price: price.value,
          quantity: ticketCount.value,
          is_dt_way: true // 是否分销订单，可选，true时后台再次查询是否分销订单，false时后台不查询

        };

        if (discountCodeId.value) {
          orderParmas.promotion_code_id = discountCodeId.value;
        }

        request.post(`${nftShopApi}/order/create_order`, orderParmas).then(orderInfoRes => {
          if (orderInfoRes.code == 200) {
            var _orderInfo$ticketCatI;

            const orderInfo = orderInfoRes.data; // 非标准iso无法识别

            const createdAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.createdAt);
            const expiresAtFormat = date2ISO(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.expiresAt);
            const salt = `${orderInfo.totalFee}_${createdAtFormat}_${SALTSTR}`;
            const enTotalFeeKey = encodeRSA(salt);
            const prepayParams = {
              pay_type: payType,
              description: orderInfo === null || orderInfo === void 0 ? void 0 : (_orderInfo$ticketCatI = orderInfo.ticketCatInfo) === null || _orderInfo$ticketCatI === void 0 ? void 0 : _orderInfo$ticketCatI.name,
              order_id: orderInfo.objectId,
              total_fee: orderInfo.totalFee,
              openid: openid,
              time_expire: expiresAtFormat,
              created_at: createdAtFormat,
              total_fee_key: enTotalFeeKey
            };
            request.post(`${nftShopApi}/pay/wechat_pay`, prepayParams).then(wechatPayRes => {
              if (wechatPayRes.code == 200) {
                if (payType == payTypeEunm.JSAPI) {
                  // JSAPI - 微信环境使用==================================
                  const {
                    appid,
                    timestamp,
                    noncestr,
                    package: wxPackage,
                    signType,
                    paySign,
                    prepay_id
                  } = wechatPayRes.data;
                  const order = AV.Object.createWithoutData("Order", orderInfo.objectId);
                  order.set("prepay_id", prepay_id);
                  order.save().then(res => {
                    initWxJssdk(() => {
                      wx.chooseWXPay({
                        timestamp: timestamp,
                        nonceStr: noncestr,
                        // 支付签名随机串，不长于 32 位
                        package: wxPackage,
                        // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: signType,
                        // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                        paySign: paySign,
                        // 支付签名
                        success: function (res) {
                          // 支付成功后的回调函数,检查支付状态
                          router.replace({
                            path: "/check-pay-status",
                            query: {
                              orderId: orderInfo.objectId
                            }
                          });
                        },
                        fail: err => {
                          Toast.fail("支付失败");
                          router.replace("/user-orders");
                        },
                        cancel: function (err) {
                          // 用户取消支付
                          Toast.fail("取消支付");
                          router.replace("/user-orders");
                        }
                      });
                    });
                  }).catch(err => {
                    Toast.fail("发起支付失败！");
                    router.replace("/user-orders");
                    console.error("保存prepay_id: ", err);
                  });
                } else if (payType == payTypeEunm.H5) {
                  // H5 - 移动端浏览器且非微信浏览器==================================
                  const {
                    h5_url,
                    order_id
                  } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

                  if (h5_url && order_id) {
                    const h5RedirectUri = encodeURIComponent(`${window.location.origin}/check-pay-status?orderId=${order_id}`);
                    window.location.href = `${h5_url}&redirect_url=${h5RedirectUri}`;
                  } else {
                    Toast.fail("发起支付失败");
                    router.replace("/user-orders");
                  }
                } else {
                  // NATIVE - PC端==================================
                  const {
                    qrcode_url,
                    order_id
                  } = wechatPayRes === null || wechatPayRes === void 0 ? void 0 : wechatPayRes.data;

                  if (order_id && qrcode_url) {
                    payQrcode.value = qrcode_url;
                    createdOrderId.value = order_id;
                    handleNativePay();
                  } else {
                    Toast.fail("支付二维码\n生成失败");
                    router.replace("/user-orders");
                  }
                }
              } else if (wechatPayRes.code != 200 && wechatPayRes.data) {
                // wechatPayRes.code == 1002 订单金额解密失败
                Toast.fail(wechatPayRes.data);
              } else {
                Toast.fail("发起支付失败");
                router.replace("/user-orders");
              }
            }).catch(err => {
              Toast.fail("发起支付错误");
              router.replace("/user-orders");
              console.error("发起支付：", err);
            });
          } else if (orderInfoRes.code != 200 && orderInfoRes.data) {
            Toast.fail(orderInfoRes.data);
          } else {
            Toast.fail("创建订单失败");
            router.replace("/user-orders");
          }
        }).catch(err => {
          console.error("创建订单：", err);
          router.replace("/user-orders");
          Toast.fail("创建订单出错");
        });
      } else {
        router.push("/login");
      }
    }; // native支付回调处理


    const timer1 = ref(null);
    const showDialog = ref(false);
    const payQrcode = ref("");
    const createdOrderId = ref("");

    const handleNativePay = () => {
      if (!showDialog.value) {
        showDialog.value = true;
      }

      request(`${nftShopApi}/order/info/${createdOrderId.value}`).then(res => {
        const {
          status
        } = res === null || res === void 0 ? void 0 : res.data;

        if (status === "paid") {
          // 支付成功跳转支付广告页
          clearTimeout(timer1.value);
          router.replace({
            path: "/add-grounp-buy",
            query: {
              orderId: createdOrderId.value
            }
          });
        } else {
          timer1.value = setTimeout(() => {
            handleNativePay();
          }, 1500);
        }
      }).catch(err => {
        showDialog.value = false;
        clearTimeout(timer1.value);
        Toast.fail("订单查询错误");
        console.error("获取订单详情：", err);
      });
    }; // 关闭分享弹窗回调


    const onCloseShareDialog = () => {
      clearTimeout(timer1.value);
      payQrcode.value = "";
      createdOrderId.value = "";
      router.replace("/user-orders");
      Toast.fail("取消支付");
    };

    return (_ctx, _cache) => {
      var _ticketInfo$value, _ticketInfo$value2, _ticketInfo$value3, _ticketInfo$value4, _ticketInfo$value5, _ticketInfo$value6, _ticketInfo$value7, _ticketInfo$value8;

      const _component_van_stepper = _resolveComponent("van-stepper");

      const _component_van_field = _resolveComponent("van-field");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "提交订单"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(priceDisplay)), 1), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(ticketInfo.value.name) + "·极客公园创新大会2023", 1)])]), _createElementVNode("div", _hoisted_10, [ticketInfo.value.cover ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: ticketInfo.value.cover,
        alt: "商品图"
      }, null, 8, _hoisted_11)) : _createCommentVNode("", true)])]), (_ticketInfo$value = ticketInfo.value) !== null && _ticketInfo$value !== void 0 && _ticketInfo$value.usefulDuration ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ticketInfo$value2 = ticketInfo.value) === null || _ticketInfo$value2 === void 0 ? void 0 : _ticketInfo$value2.usefulDuration, (date, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: date
        }, [_createElementVNode("span", {
          class: _normalizeClass(['use-date-text-title', index != 0 ? 'hidden' : ''])
        }, "可用日期：", 2), _createTextVNode(_toDisplayString(date), 1)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_hoisted_14, ticketInfo.value.type == 1 || ticketInfo.value.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_15, "同一订单购买多张票券时仅显示一个票券二维码，可在现场直接兑换多个入场凭证；")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_component_van_stepper, {
        modelValue: ticketCount.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ticketCount.value = $event),
        disabled: ticketInfo.value.type == 2,
        "button-size": "18",
        min: "1",
        max: "99",
        integer: "",
        "before-change": onCountBeforeChange
      }, null, 8, ["modelValue", "disabled"])]), ticketInfo.value.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_19, "同一票品每满2件，第2件享受半价优惠哦")) : _createCommentVNode("", true), ticketInfo.value.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_20, "学生专享价格，每种票品限购一张")) : _createCommentVNode("", true)]), ticketInfo.value.type == 1 || ticketInfo.value.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_van_cell_group, {
        inset: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: discountCode.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => discountCode.value = $event),
          label: "优惠码",
          placeholder: "输入6位数优惠码",
          "input-align": "right",
          type: "text",
          "error-message": verificationInfo.value,
          "error-message-align": "right"
        }, null, 8, ["modelValue", "error-message"])]),
        _: 1
      })]), _unref(discountCodeRateDispaly) ? (_openBlock(), _createElementBlock("div", _hoisted_23, "您已享受 " + _toDisplayString(_unref(discountCodeRateDispaly)) + " 折优惠", 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, "￥" + _toDisplayString(_unref(ticketOriginTotalFeeDisplay)), 1)]), ticketInfo.value.type == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", null, "- ¥ " + _toDisplayString(_unref(secondHalfDiscountDisplay) || "0"), 1)])) : _createCommentVNode("", true), ticketInfo.value.type == 1 || ticketInfo.value.type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", null, "- ¥ " + _toDisplayString(_unref(discountCodeAmountDisplay) || "0"), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("div", _hoisted_36, [_hoisted_37, _createElementVNode("span", null, _toDisplayString(_unref(totalFeeDisplay)), 1)])])])]), _hoisted_38]), _createVNode(_unref(VanDialog), {
        class: "share-img-dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => showDialog.value = $event),
        onClose: onCloseShareDialog,
        showConfirmButton: false,
        closeOnClickOverlay: true,
        "lazy-render": false
      }, {
        default: _withCtx(() => [_hoisted_40, _createElementVNode("div", _hoisted_41, [payQrcode.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "share-img",
          src: payQrcode.value
        }, null, 8, _hoisted_42)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["show"])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, "订单合计：￥" + _toDisplayString(_unref(totalFeeDisplay)), 1), (_ticketInfo$value3 = ticketInfo.value) !== null && _ticketInfo$value3 !== void 0 && _ticketInfo$value3.type ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [((_ticketInfo$value4 = ticketInfo.value) === null || _ticketInfo$value4 === void 0 ? void 0 : _ticketInfo$value4.type) != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_createVNode(CommonBtn, {
        id: "ga4-pay-now",
        text: "立即支付",
        width: "132px",
        height: "32px",
        onHandleClick: onBuy
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_46, [!((_ticketInfo$value5 = ticketInfo.value) !== null && _ticketInfo$value5 !== void 0 && _ticketInfo$value5.beBuiedStudent) && ((_ticketInfo$value6 = ticketInfo.value) === null || _ticketInfo$value6 === void 0 ? void 0 : _ticketInfo$value6.beBuiedStudent) !== false ? (_openBlock(), _createElementBlock("div", _hoisted_47)) : _createCommentVNode("", true), ((_ticketInfo$value7 = ticketInfo.value) === null || _ticketInfo$value7 === void 0 ? void 0 : _ticketInfo$value7.beBuiedStudent) === true ? (_openBlock(), _createElementBlock("div", _hoisted_48, "已购买过")) : _createCommentVNode("", true), ((_ticketInfo$value8 = ticketInfo.value) === null || _ticketInfo$value8 === void 0 ? void 0 : _ticketInfo$value8.beBuiedStudent) === false ? (_openBlock(), _createBlock(CommonBtn, {
        key: 2,
        id: "ga4-pay-now",
        text: "立即支付",
        width: "132px",
        height: "32px",
        onHandleClick: onBuy
      })) : _createCommentVNode("", true)]))], 64)) : _createCommentVNode("", true)])], 64);
    };
  }

};